import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Chip, CircularProgress } from '@mui/material';
import { useIntl } from 'react-intl';

export interface ListViewLoadMoreProps {
  onLoadMore: () => void;
  isLoadingMore: boolean;
}

/**
 * Chip button that loads the next page of an infinite list.
 * Shows a spinner as label when loading, otherwise "Load more" with chevron icon.
 */
export function ListViewLoadMore({ onLoadMore, isLoadingMore }: ListViewLoadMoreProps) {
  const { $t } = useIntl();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
      <Chip
        label={
          isLoadingMore
            ? null
            : $t({
                id: 'common.loadMore',
                defaultMessage: 'Mostrar anteriores',
              })
        }
        onClick={onLoadMore}
        disabled={isLoadingMore}
        icon={isLoadingMore ? <CircularProgress size={16} color="inherit" /> : <ExpandMoreIcon />}
        sx={{ minWidth: 140 }}
      />
    </Box>
  );
}
